/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CourierPackage } from './CourierPackage';
// Note: CourierPackage conversion functions are NOT imported here to avoid circular dependency
// CourierPackage.ts imports Invoice, so we break the cycle by not importing CourierPackage converters
import { CourierUser, CourierUserFromJSON, CourierUserToJSON } from './CourierUser';
import type { InvoiceItem } from './InvoiceItem';
import {
    InvoiceItemFromJSON,
    InvoiceItemFromJSONTyped,
    InvoiceItemToJSON,
    InvoiceItemToJSONTyped,
} from './InvoiceItem';

/**
 * 
 * @export
 * @interface Invoice
 */
export interface Invoice {
    /**
     * 
     * @type {Array<InvoiceItem>}
     * @memberof Invoice
     */
    items?: Array<InvoiceItem>;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof Invoice
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof Invoice
     */
    discount?: number;
    /**
     * 
     * @type {Date}
     * @memberof Invoice
     */
    created?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Invoice
     */
    dateDue?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof Invoice
     */
    sentInEmail?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof Invoice
     */
    datePaid?: Date;
    /**
     * 
     * @type {number}
     * @memberof Invoice
     */
    cashierId?: number;
    cashier?: CourierUser;
    /**
     * 
     * @type {number}
     * @memberof Invoice
     */
    cashCollected?: number;
    /**
     * 
     * @type {number}
     * @memberof Invoice
     */
    bankTransfer?: number;
    /**
     * 
     * @type {number}
     * @memberof Invoice
     */
    cardAmount?: number;
    /**
     * Customer credit balance applied to this invoice as a tender.
     * @type {number}
     * @memberof Invoice
     */
    creditApplied?: number;
    /**
     * Money value of the reward points redeemed against this invoice.
     * @type {number}
     * @memberof Invoice
     */
    pointsApplied?: number;
    /**
     * Raw count of reward points redeemed against this invoice.
     * @type {number}
     * @memberof Invoice
     */
    pointsRedeemed?: number;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    collectedBy?: string;
    /**
     * 
     * @type {number}
     * @memberof Invoice
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof Invoice
     */
    customerId?: number;
    /**
     * 
     * @type {number}
     * @memberof Invoice
     */
    businessId?: number;
    /**
     * 
     * @type {number}
     * @memberof Invoice
     */
    courierPackageId?: number;
    /**
     * 
     * @type {number}
     * @memberof Invoice
     */
    deliveryRequestId?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof Invoice
     */
    attachedFile?: Array<string>;

    customer?: CourierUser;
    courierPackage?: CourierPackage;
    signature?: string;
    /**
     *
     * @type {boolean}
     * @memberof Invoice
     */
    isCustomInvoice?: boolean;
    /**
     * Array of package IDs for multi-package invoices
     * @type {Array<number>}
     * @memberof Invoice
     */
    courierPackageIds?: Array<number>;
    /**
     * Type: 'single', 'multi-package', 'custom'
     * @type {string}
     * @memberof Invoice
     */
    invoiceType?: string;
    /**
     * Document type: 'Invoice' or 'Quote'
     * @type {string}
     * @memberof Invoice
     */
    docType?: string;
    /**
     * Human-friendly sequential number per courier, e.g. INV-0001 / QUO-0001
     * @type {string}
     * @memberof Invoice
     */
    invoiceNumber?: string;
    /**
     * Recipient name for walk-in / ad-hoc invoices with no registered customer
     * @type {string}
     * @memberof Invoice
     */
    recipientName?: string;
    /**
     * Recipient email for walk-in / ad-hoc invoices
     * @type {string}
     * @memberof Invoice
     */
    recipientEmail?: string;
    /**
     * Recipient phone for walk-in / ad-hoc invoices
     * @type {string}
     * @memberof Invoice
     */
    recipientPhone?: string;
    /**
     * Free-text notes rendered on the invoice/quote PDF
     * @type {string}
     * @memberof Invoice
     */
    notes?: string;
    /**
     * Free-text terms rendered on the invoice/quote PDF
     * @type {string}
     * @memberof Invoice
     */
    terms?: string;
    /**
     * Optional tax (e.g. GCT) percentage applied to (subtotal - discount)
     * @type {number}
     * @memberof Invoice
     */
    taxRate?: number;
    /**
     * Original quote id when this invoice was created by converting a quote
     * @type {number}
     * @memberof Invoice
     */
    convertedFromQuoteId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Invoice
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof Invoice
     */
    deletedOn?: Date;
}

/**
 * Check if a given object implements the Invoice interface.
 */
export function instanceOfInvoice(value: object): value is Invoice {
    return true;
}

export function InvoiceFromJSON(json: any): Invoice {
    return InvoiceFromJSONTyped(json, false);
}

export function InvoiceFromJSONTyped(json: any, ignoreDiscriminator: boolean): Invoice {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(InvoiceItemFromJSON)),
        'status': json['status'] == null ? undefined : json['status'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'discount': json['discount'] == null ? undefined : json['discount'],
        'created': json['created'] == null ? undefined : (new Date(json['created'])),
        'dateDue': json['dateDue'] == null ? undefined : (new Date(json['dateDue'])),
        'sentInEmail': json['sentInEmail'] == null ? undefined : json['sentInEmail'],
        'datePaid': json['datePaid'] == null ? undefined : (new Date(json['datePaid'])),
        'cashierId': json['cashierId'] == null ? undefined : json['cashierId'],
        'cashCollected': json['cashCollected'] == null ? undefined : json['cashCollected'],
        'bankTransfer': json['bankTransfer'] == null ? undefined : json['bankTransfer'],
        'cardAmount': json['cardAmount'] == null ? undefined : json['cardAmount'],
        'creditApplied': json['creditApplied'] == null ? undefined : json['creditApplied'],
        'pointsApplied': json['pointsApplied'] == null ? undefined : json['pointsApplied'],
        'pointsRedeemed': json['pointsRedeemed'] == null ? undefined : json['pointsRedeemed'],
        'referenceNumber': json['referenceNumber'] == null ? undefined : json['referenceNumber'],
        'collectedBy': json['collectedBy'] == null ? undefined : json['collectedBy'],
        'id': json['id'] == null ? undefined : json['id'],
        'customerId': json['customerId'] == null ? undefined : json['customerId'],
        'businessId': json['businessId'] == null ? undefined : json['businessId'],
        'courierPackageId': json['courierPackageId'] == null ? undefined : json['courierPackageId'],
        'deliveryRequestId': json['deliveryRequestId'] == null ? undefined : json['deliveryRequestId'],
        'attachedFile': json['attachedFile'] == null ? undefined : json['attachedFile'],
        'customer': json['customer'] == null ? undefined : CourierUserFromJSON(json['customer']),
        'courierPackage': json['courierPackage'] == null ? undefined : json['courierPackage'] as CourierPackage,
        'signature': json['signature'] == null ? undefined : json['signature'],
        'cashier': json['cashier'] == null ? undefined : CourierUserFromJSON(json['cashier']),
        'isCustomInvoice': json['isCustomInvoice'] == null ? undefined : json['isCustomInvoice'],
        'courierPackageIds': json['courierPackageIds'] == null ? undefined : json['courierPackageIds'],
        'invoiceType': json['invoiceType'] == null ? undefined : json['invoiceType'],
        'docType': json['docType'] == null ? undefined : json['docType'],
        'invoiceNumber': json['invoiceNumber'] == null ? undefined : json['invoiceNumber'],
        'recipientName': json['recipientName'] == null ? undefined : json['recipientName'],
        'recipientEmail': json['recipientEmail'] == null ? undefined : json['recipientEmail'],
        'recipientPhone': json['recipientPhone'] == null ? undefined : json['recipientPhone'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'terms': json['terms'] == null ? undefined : json['terms'],
        'taxRate': json['taxRate'] == null ? undefined : json['taxRate'],
        'convertedFromQuoteId': json['convertedFromQuoteId'] == null ? undefined : json['convertedFromQuoteId'],
        'isDeleted': json['isDeleted'] == null ? undefined : json['isDeleted'],
        'deletedOn': json['deletedOn'] == null ? undefined : (new Date(json['deletedOn'])),
    };
}

export function InvoiceToJSON(json: any): Invoice {
    return InvoiceToJSONTyped(json, false);
}

export function InvoiceToJSONTyped(value?: Invoice | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(InvoiceItemToJSON)),
        'status': value['status'],
        'amount': value['amount'],
        'discount': value['discount'],
        'created': value['created'] == null ? undefined : ((value['created']).toISOString()),
        'dateDue': value['dateDue'] == null ? undefined : ((value['dateDue']).toISOString()),
        'sentInEmail': value['sentInEmail'],
        'datePaid': value['datePaid'] == null ? undefined : ((value['datePaid']).toISOString()),
        'cashierId': value['cashierId'],
        'cashCollected': value['cashCollected'],
        'bankTransfer': value['bankTransfer'],
        'cardAmount': value['cardAmount'],
        'creditApplied': value['creditApplied'],
        'pointsApplied': value['pointsApplied'],
        'pointsRedeemed': value['pointsRedeemed'],
        'referenceNumber': value['referenceNumber'],
        'collectedBy': value['collectedBy'],
        'id': value['id'],
        'customerId': value['customerId'],
        'businessId': value['businessId'],
        'courierPackageId': value['courierPackageId'],
        'deliveryRequestId': value['deliveryRequestId'],
        'attachedFile': value['attachedFile'],
        'customer': value['customer'] == null ? undefined : CourierUserToJSON(value['customer']),
        'courierPackage': value['courierPackage'],
        'signature': value['signature'],
        'cashier': value['cashier'] == null ? undefined : CourierUserToJSON(value['cashier']),
        'isCustomInvoice': value['isCustomInvoice'],
        'courierPackageIds': value['courierPackageIds'],
        'invoiceType': value['invoiceType'],
        'docType': value['docType'],
        'invoiceNumber': value['invoiceNumber'],
        'recipientName': value['recipientName'],
        'recipientEmail': value['recipientEmail'],
        'recipientPhone': value['recipientPhone'],
        'notes': value['notes'],
        'terms': value['terms'],
        'taxRate': value['taxRate'],
        'convertedFromQuoteId': value['convertedFromQuoteId'],
        'isDeleted': value['isDeleted'],
        'deletedOn': value['deletedOn'] == null ? undefined : ((value['deletedOn']).toISOString()),
    };
}

